export const partnerContent = {
    verizon: {
        sellClosingContent: [],
        sellSmartOfferContent: [
            {
                sectionTitle: "Sell",
                sectionGroups: [
                    {
                        heading:
                            "Follow your Call Flow and use the Smart Offer to make a quality sale. Close the call with warmth and excitement.",
                        bulletPoints: [],
                    },
                ],
            },
        ],
        serveSolveContent: [
            {
                sectionTitle: "Serve",
                sectionGroups: [
                    {
                        heading:
                            "Greet and verify your customer, then offer compassion and reassurance. Follow the steps in your call flow.",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Solve",
                sectionGroups: [
                    {
                        heading:
                            "Use your tools to troubleshoot the customer’s issue. Continue to connect with the customer genuinely and build a relationship while you solve. When the issue is resolved, test and confirm the resolution.",
                        bulletPoints: [],
                    },
                ],
            },
        ],
    },
    att: {
        sellClosingContent: [],
        sellSmartOfferContent: [
            {
                sectionTitle: "Sell",
                sectionGroups: [
                    {
                        heading:
                            "Follow your Call Flow and use the Smart Offer to make a quality sale. Close the call with warmth and excitement.",
                        bulletPoints: [],
                    },
                ],
            },
        ],
        serveSolveContent: [
            {
                sectionTitle: "Serve",
                sectionGroups: [
                    {
                        heading:
                            "Greet and verify your customer, then offer compassion and reassurance. Follow the steps in your call flow.",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Solve",
                sectionGroups: [
                    {
                        heading:
                            "Use your tools to troubleshoot the customer’s issue. Continue to connect with the customer genuinely and build a relationship while you solve. When the issue is resolved, test and confirm the resolution.",
                        bulletPoints: [],
                    },
                ],
            },
        ],
    },
    amazonrouter: {
        serveSolveContent: [],
        sellSmartOfferContent: [
            {
                sectionTitle: "Transition Statement",
                sectionGroups: [
                    {
                        heading:
                            "“Before you go, I do want to quickly share an option that a lot of customers find helpful. It’s called Asurion Complete Protect, and it gives you one simple protection plan for your eligible Amazon purchases.”",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Discovery Question",
                sectionGroups: [
                    {
                        heading: "Choose ONE of these options:",
                        bulletPoints: [
                            "“How often do you find yourself shopping on Amazon?”",
                            "“What kind of items do you usually buy on Amazon?”​",
                            "“Do you mostly shop for everyday items or higher-ticket products like electronics?”",
                        ],
                    },
                ],
            },
            {
                sectionTitle: "Engagement Question",
                sectionGroups: [
                    {
                        heading: "Choose ONE of these options:",
                        bulletPoints: [
                            "“Would you say Amazon is your go to before checking out stores?”​",
                            "“Are those products getting daily use, and what are they mainly used for?”​​​",
                            "“ What do you usually do when your tech stops working?”",
                        ],
                    },
                ],
            },
            {
                sectionTitle: "Core Benefits",
                sectionGroups: [
                    {
                        heading: "",
                        bulletPoints: [
                            "“Asurion Complete Protect covers eligible Amazon purchases you’ve made in the last 90 days, and any eligible purchases you make going forward.”",
                            "“Coverage starts right away and covers things like malfunctions or failures and even drops or spills on eligible portable items. If something happens, we will assist you with a repair or reimbursement for the original purchase price.”​​",
                            "“Asurion Complete Protect also includes access to Norton 360 Deluxe, which provides trusted cybersecurity to help keep your devices and personal information safer, including advanced scam detection for emails and texts.”",
                        ],
                    },
                ],
            },
            {
                sectionTitle: "Examples of Coverage",
                sectionGroups: [
                    {
                        heading:
                            "1-3 examples will be surfaced from a bank of statements, matching a product the customer mentioned to a coverage benefit of the home plan.",
                        bulletPoints: [
                            "Example: “Your Laptop would be protected from Accidental Damage from Handling.”",
                        ],
                    },
                ],
            },
            {
                sectionTitle: "Price",
                sectionGroups: [
                    {
                        heading: "“It’s $16.99 plus tax, per month”",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Ask for Sale",
                sectionGroups: [
                    {
                        heading: "“May I help you get started with your enrollment?”",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Ask to Send Link",
                sectionGroups: [
                    {
                        heading:
                            "“Can I text you a link to review important plan information and complete your enrollment?”",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Resolve Concern",
                sectionGroups: [
                    {
                        heading: "Rebuttal verbiage accessible within the tool at any time during the offer",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Track the Sale",
                sectionGroups: [
                    {
                        heading:
                            "“Let me know if you have any questions as you review it. Once you subscribe, could you share the order number with me please?”",
                        bulletPoints: [],
                    },
                ],
            },
            {
                sectionTitle: "Celebrate Enrollment",
                sectionGroups: [
                    {
                        heading:
                            "“Congratulations on signing up for Asurion Complete Protect, be on the lookout for a welcome email within the next few days with full details about all of the amazing benefits!”",
                        bulletPoints: [],
                    },
                ],
            },
        ],
        sellClosingContent: [],
    },
};
